import { create } from 'zustand';
import { DEFAULT_BODY, type FenderStyle, type WheelFinish } from './components/truck/paints';

export interface BadgeParams {
  width: number;
  height: number;
  thickness: number;
  cornerHoleRadius: number;
  motifRadius: number;
  engrave: boolean;
}

export type Mood = 'tramonto' | 'notte';

export interface TruckConfig {
  bodyColor: string;
  fenders: FenderStyle;
  wheels: WheelFinish;
  showAwning: boolean;
  showLights: boolean;
  showBar: boolean;
  showSignage: boolean;
}

interface ConfigState extends TruckConfig {
  tab: 'truck' | 'badge';
  setTab: (tab: 'truck' | 'badge') => void;

  // Truck
  setTruck: (patch: Partial<TruckConfig>) => void;
  mood: Mood;
  setMood: (mood: Mood) => void;

  // Badge
  badge: BadgeParams;
  setBadge: (patch: Partial<BadgeParams>) => void;
}

export const useConfig = create<ConfigState>((set) => ({
  tab: 'truck',
  setTab: (tab) => set({ tab }),

  // Truck — defaults reproduce the tuned "Tipsy pink" look
  bodyColor: DEFAULT_BODY,
  fenders: 'tono',
  wheels: 'nero',
  showAwning: true,
  showLights: true,
  showBar: true,
  showSignage: true,
  setTruck: (patch) => set(patch),
  mood: 'tramonto',
  setMood: (mood) => set({ mood }),

  badge: {
    width: 60,
    height: 24,
    thickness: 4,
    cornerHoleRadius: 2.5,
    motifRadius: 6,
    engrave: true,
  },
  setBadge: (patch) => set((s) => ({ badge: { ...s.badge, ...patch } })),
}));
